const getByPath = require('../utils/objects/getByPath');

const configuration = !process.env.CLIENT ? require('./configuration').default : {}; // eslint-disable-line import/no-unresolved, global-require

let configurationObject;

function flatten(object, separator = '.') {
  function processFlatten(child, path = []) {
    // eslint-disable-next-line no-confusing-arrow
    return [].concat(...Object.keys(child).map((key) => typeof child[key] === 'object'
      ? processFlatten(child[key], path.concat([key]))
      : ({ [path.concat([key]).join(separator)]: child[key] })
    ));
  }

  return Object.assign({}, ...processFlatten(object));
}

const Configuration = {
  use(customConfiguration) {
    configurationObject = customConfiguration;
    return this;
  },
  get(keyPath) {
    return getByPath(configurationObject || configuration, keyPath);
  },
  fromJSON(json) {
    configurationObject = json;
  },
  toJSON() {
    return JSON.parse(JSON.stringify(configuration));
  },
  map(mapper) {
    return mapper(this);
  },
  flatten(keyPath) {
    return Object.values(flatten(this.get(keyPath)));
  }
};

if (process.env.CLIENT) {
  const configurationJSON = window.CONFIGURATION;
  delete window.CONFIGURATION;
  Configuration.fromJSON(configurationJSON);
}

export default Configuration;
